var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 20L20.2534 16L13.3334 12V20ZM28.7467 9.56002C28.9201 10.1867 29.0401 11.0267 29.1201 12.0934C29.2134 13.16 29.2534 14.08 29.2534 14.88L29.3334 16C29.3334 18.92 29.1201 21.0667 28.7467 22.44C28.4134 23.64 27.6401 24.4134 26.4401 24.7467C25.8134 24.92 24.6667 25.04 22.9067 25.12C21.1734 25.2134 19.5867 25.2534 18.1201 25.2534L16.0001 25.3334C10.4134 25.3334 6.93341 25.12 5.56008 24.7467C4.36008 24.4134 3.58675 23.64 3.25341 22.44C3.08008 21.8134 2.96008 20.9734 2.88008 19.9067C2.78675 18.84 2.74675 17.92 2.74675 17.12L2.66675 16C2.66675 13.08 2.88008 10.9334 3.25341 9.56002C3.58675 8.36002 4.36008 7.58669 5.56008 7.25335C6.18675 7.08002 7.33342 6.96002 9.09342 6.88002C10.8267 6.78669 12.4134 6.74669 13.8801 6.74669L16.0001 6.66669C21.5867 6.66669 25.0667 6.88002 26.4401 7.25335C27.6401 7.58669 28.4134 8.36002 28.7467 9.56002Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon_youtube.cbc61f689c79157446e07dee1cf0ee78.svg";
export { ForwardRef as ReactComponent };